var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaqLoan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 3.75C18 3.33579 17.6642 3 17.25 3H12C8.68629 3 6 5.68629 6 9V27C6 30.3137 8.68629 33 12 33H24C27.3137 33 30 30.3137 30 27V15.75C30 15.3358 29.6642 15 29.25 15H25.5C21.3579 15 18 11.6421 18 7.5V3.75ZM28.8292 12C29.3279 12 29.6864 11.5184 29.4468 11.081C29.2434 10.7095 28.9868 10.3655 28.682 10.0607L22.9393 4.31802C22.6345 4.0132 22.2905 3.75662 21.919 3.55321C21.4816 3.31363 21 3.67207 21 4.17082V7.5C21 9.98528 23.0147 12 25.5 12H28.8292ZM13.5 13.5C12.6716 13.5 12 14.1716 12 15C12 15.8284 12.6716 16.5 13.5 16.5H15C15.8284 16.5 16.5 15.8284 16.5 15C16.5 14.1716 15.8284 13.5 15 13.5H13.5ZM12 21C12 20.1716 12.6716 19.5 13.5 19.5H22.5C23.3284 19.5 24 20.1716 24 21C24 21.8284 23.3284 22.5 22.5 22.5H13.5C12.6716 22.5 12 21.8284 12 21ZM12 27C12 26.1716 12.6716 25.5 13.5 25.5H22.5C23.3284 25.5 24 26.1716 24 27C24 27.8284 23.3284 28.5 22.5 28.5H13.5C12.6716 28.5 12 27.8284 12 27Z",
    fill: "#6D57DF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqLoan);
export default __webpack_public_path__ + "static/media/FaqLoan.af64bd54536af2b598bc50701eca4b5d.svg";
export { ForwardRef as ReactComponent };